import { Badge, Box, Button, Drawer, IconButton } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { PropsWithChildren, useState } from 'react';
import { gridQuickFilterValuesSelector, useGridApiContext } from '@mui/x-data-grid-pro';
import { StyledQuickFilter } from '@components/DataGrid/StyledComponents';

import styles from './Dispatch/DataGrid.Dispatch.module.css';
import QuickFilterOperatorDropdown from './QuickFilterOperatorDropdown';

/**
 * Filters that are visible in desktop will be displayed here in a drawer when the filter icon is clicked.
 */
export default function MobileFilterMenu(props: PropsWithChildren) {
  const [open, setIsOpen] = useState(false);
  const gridContext = useGridApiContext();

  // Try to find the appbar and align with the bottom of it. Default to app bar height.
  // There seems to be a render race where this component is happening before the Appbar exists.
  const appBar = document.getElementsByTagName('header');
  const marginTop = `${String(appBar.length > 0 ? appBar[0].getBoundingClientRect().bottom : 48)}px`;

  return (
    <>
      <IconButton
        title='View Filters'
        className={`${styles['icon-btn']} ${styles['mobile-filter-btn']}`}
        onClick={() => {
          setIsOpen(true);
        }}>
        <Badge
          color='primary'
          variant='dot'
          invisible={(gridQuickFilterValuesSelector(gridContext)?.length ?? 0) === 0}>
          <FilterListIcon fontSize='inherit' />
        </Badge>
      </IconButton>

      <Drawer
        anchor='top'
        open={open}
        onClose={() => {
          setIsOpen(false);
        }}
        slotProps={{
          paper: {
            className: styles['drawer-paper']
          }
        }}
        transitionDuration={300}>
        <Box
          sx={{ marginTop: marginTop }}
          role='presentation'
          className={styles.menu}>
          <span className={styles.title}>FILTERS</span>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <StyledQuickFilter
              className={styles['mobile-quick-filter']}
              inputClassName={styles['quick-filter-input']}
              placeholder='Filter by Keyword'
              debounceMs={300}
              defaultExpanded
            />

            <QuickFilterOperatorDropdown />
          </div>

          {props.children}

          <Button
            variant='contained'
            onClick={() => {
              setIsOpen(false);
            }}
            className={styles['close-filters-btn']}>
            Close
          </Button>
        </Box>
      </Drawer>
    </>
  );
}
